/*
 * https://github.com/5orenso
 *
 * Copyright (c) 2026 Øistein Sørensen
 * Licensed under the MIT license.
 */

/*
 * A Norwegian organisation number is 9 digits, but it is rarely stored bare: the value we
 * print in the invoice footer is what the company is required to show, and that is
 * typically `832195162 MVA` (or `NO 832 195 162 MVA` / `Org.nr 832 195 162`). Users must be
 * able to type that whole string, so validation and every consumer that needs the number
 * itself pull the 9 digits back out instead of demanding a bare 9-digit input.
 */

// Grouping separators only count as separators when digits follow them, so the space in
// `832195162 MVA` is kept as a real boundary while `832 195 162` is collapsed.
const SEPARATORS_BEFORE_DIGIT = /[\s.-]+(?=\d)/g;
const NINE_DIGITS = /(?:^|\D)(\d{9})(?!\d)/;

export const extractOrgNumber = (input) => {
    if (input === null || input === undefined || input === '') {
        return '';
    }
    const compact = String(input).replace(SEPARATORS_BEFORE_DIGIT, '');
    const match = compact.match(NINE_DIGITS);
    return match ? match[1] : '';
};

export default { extractOrgNumber };
